module.exports = "/_next/static/images/a0d453eb5b6231d0a4c1523576f750d8-rewards-app-xs@1x.png.webp";